import type { QueryClient } from "react-query";

import type { CheckoutSession } from "@/react/types/Paywalls/Checkout/Session";

import { getCheckoutSessionQueryKey } from "./getCheckoutSessionQueryKey";

export const updateSessionCache = (
  queryClient: QueryClient,
  paywallId: number,
  updatedSession: CheckoutSession,
): void => {
  queryClient.setQueryData(
    getCheckoutSessionQueryKey(paywallId),
    updatedSession,
  );
};
